import { FC } from 'react'
import { LinkCustomerToServiceWidget } from 'Integrations/integrationsConfig/common/LinkEntities/LinkCustomerToService'

export const LinkGoCardlessCustomerWidget: FC<{
  customerId: string
}> = props => (
  <LinkCustomerToServiceWidget
    customerId={props.customerId}
    externalEntityLabel="customer"
    sequenceEntityLabel="customer"
    service="GoCardless"
  />
)
